import { render } from "./DealsDashboard.vue?vue&type=template&id=9576e928"
import script from "./DealsDashboard.vue?vue&type=script&lang=js"
export * from "./DealsDashboard.vue?vue&type=script&lang=js"

import "./DealsDashboard.vue?vue&type=style&index=0&id=9576e928&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__